<template>
  <el-scrollbar always class="v100">
    <div class="common-layout">
      <Header v-if="isShow" ></Header>
      <router-view v-if="isRefresh"></router-view>
    </div>
  </el-scrollbar>
</template>

<script lang="ts" setup>
import {watch, ref,nextTick, provide} from 'vue'
import {useRoute} from 'vue-router'

const route = useRoute()
let isShow = ref(true)
const isRefresh = ref(true)
const reload = ()=>{
  isRefresh.value = false
  nextTick(()=>{
    isRefresh.value = true
  })
}
provide('reload', reload)

watch(() => route.meta,(nv)=>{
  if(nv.isHeader){
    isShow.value = false
  }
})
</script>
<style scoped>
.v100 {
  height:100vh!important;
}
.common-layout {
  display: flex;
  flex-direction: column;
}
</style>